export default {

    SERVICE_LANGUAGES:['ko','en','ja'],
    SERVICE_DEFAULT_LANGUAGE:'ko',

    language:'ko',
    base_url:'/ko',

    LANGUAGE:'ko',
    BASE_URL:'/ko',

    //API_BASE_URL: 'https://www-dev.angeltrip.co/ko/api/v1',
    API_BASE_URL: 'https://www-dev.1day1job.com/ko/api/v1', // Full uRL
    API_URL: '/ko/api/v1',
    API_VER:'v1',
   

    SERVICE_TITLE: '1Day1Job',
    SERVICE_DOMAIN: 'https://www-dev.angelbridge.co',




};